export const getToken = () => localStorage.getItem("sellerdash-token");
export const setToken = (token: string) =>
  localStorage.setItem("sellerdash-token", token);
export const removeToken = () => localStorage.removeItem("sellerdash-token");
